import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-433a6434"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"min-width":"600px","max-width":"600px"},
  class: "flex col"
}
const _hoisted_2 = { class: "flex justify-between align-center" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "grid custom-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeTab = _resolveComponent("SeTab")!
  const _component_SeCheckBox = _resolveComponent("SeCheckBox")!
  const _component_WideCard = _resolveComponent("WideCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SeTab, {
      onTabChange: _ctx.onTabChange,
      id: "tab",
      ref: "tab",
      tabs: _ctx.store ? [
      _ctx.Lang.getI18N('my-temperatures'),
      _ctx.Lang.getI18N('delivery'),
      _ctx.Lang.getI18N('probes'),
    ] : ['Température', 'Livraison']
    }, null, 8, ["onTabChange", "tabs"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SeCheckBox, {
        ref: "selectAll",
        onClick: _ctx.onSelectAllClicked
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Lang.getI18N("select-all")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedElements, (item, index) => {
        return (_openBlock(), _createBlock(_component_WideCard, {
          key: index,
          obj: item,
          icon: item.getIllustrationUrl() != '' && item.getIllustrationUrl() != null
        ? _ctx.ImageUtils.toImageKit(item.getIllustrationUrl())
        : '/ico/equipement.svg'
        ,
          onClick: ($event: any) => (_ctx.toggleCheckBox(item))
        }, {
          subtitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.getName()), 1)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_SeCheckBox, {
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              ref_for: true,
              ref: index,
              style: {"align-self":"center"},
              checked: _ctx.alreadySelected(item),
              id: item.ref.id
            }, null, 8, ["checked", "id"])
          ]),
          _: 2
        }, 1032, ["obj", "icon", "onClick"]))
      }), 128))
    ])
  ]))
}